import { DashboardControlsProvider } from 'contexts/Dashboard/useDashboardControls';
import { useMemo } from 'react';
import useHasAccessToRiddermarkReporting from 'hooks/useHasAccessToRiddermarkReporting';
import ViewActionsBar from '../../../components/Dashboard/ViewActionsBar';
import {
  KPIsWidgetEnum,
  RiddermarkBaseWidgets,
  RiddermarkManagementWidgets,
} from '../utils';
import RiddermarkKPIsFilterBar from './RiddermarkKPIsFilterBar';
import RiddermarkDashboardKPIs from './RiddermarkDashboardKPIs';

/**
 * RM-nyckeltal.
 *
 * Vyn i sig kräver bara rollen RiddermarkLedning — avbokningar, avvikande jobb, fel på bil och
 * leveransskick har inget med ledningsrapporten att göra. Det är ledningsrapportens sju widgetar
 * som ligger bakom feature-flaggan, och de läggs till i listan först när användaren har den.
 *
 * Grinden sitter på listan och inte på renderingen. Listan som skickas hit är också den
 * widgetväljaren visar, så utan flaggan finns de sju inte att välja — de blir inte tomma rutor
 * eller bortfiltrerade kryssrutor, de finns inte. En markering som ligger kvar i localStorage
 * från tiden före flaggan följer inte med, eftersom providern bygger om listan ur den här.
 */
const RiddermarkKPIsPage = () => {
  const hasManagementReporting = useHasAccessToRiddermarkReporting();

  const widgets = useMemo(
    () =>
      hasManagementReporting
        ? [...RiddermarkBaseWidgets, ...RiddermarkManagementWidgets]
        : RiddermarkBaseWidgets,
    [hasManagementReporting]
  );

  return (
    <DashboardControlsProvider<KPIsWidgetEnum>
      storageKey="RiddermarkKPIs"
      defaultWidgets={widgets}
    >
      <RiddermarkKPIsFilterBar />
      <ViewActionsBar />
      <RiddermarkDashboardKPIs />
    </DashboardControlsProvider>
  );
};

export default RiddermarkKPIsPage;
